import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AspInstantOrderQuoteComponent } from './asp-instant-order-quote.component';
import { MatTooltipModule } from '@angular/material/tooltip';
const routes: Routes = [
  {
      path: 'magic-quote/:id',
      component: AspInstantOrderQuoteComponent,
  },
];


@NgModule({
  declarations: [AspInstantOrderQuoteComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    MatTooltipModule
  ],
  exports:[AspInstantOrderQuoteComponent],
})
export class AspInstantOrderQuoteModule { }
